import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Trash2, UserCheck, Shield, User } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PendingUserList from "./PendingUserList";
import UserList from "./UserList";

// Mock data for demonstration
const mockUsers = [
  {
    id: "1",
    username: "alice.johnson",
    email: "alice.johnson@example.com",
    role: "Admin",
    status: "Active",
    joinDate: "2024-01-15"
  },
  {
    id: "2", 
    username: "bob.smith",
    email: "bob.smith@example.com",
    role: "User",
    status: "Active",
    joinDate: "2024-02-08"
  },
  {
    id: "3",
    username: "charlie.brown",
    email: "charlie.brown@example.com", 
    role: "User",
    status: "Pending",
    joinDate: "2024-03-12"
  },
  {
    id: "4",
    username: "diana.prince",
    email: "diana.prince@example.com",
    role: "Moderator",
    status: "Active", 
    joinDate: "2024-01-22"
  },
  {
    id: "5",
    username: "edward.norton",
    email: "edward.norton@example.com",
    role: "User",
    status: "Inactive",
    joinDate: "2023-12-05"
  }
].sort((a, b) => a.username.localeCompare(b.username));

const getRoleIcon = (role: string) => {
  switch (role) {
    case 'Admin':
      return <Shield className="h-4 w-4" />;
    case 'Moderator':
      return <UserCheck className="h-4 w-4" />;
    default:
      return <User className="h-4 w-4" />;
  }
};

const getStatusBadgeVariant = (status: string) => {
  switch (status) {
    case 'Active':
      return 'default';
    case 'Pending':
      return 'secondary';
    case 'Inactive':
      return 'outline';
    default:
      return 'secondary';
  }
};

/**
 * Renders a user management interface with tabs for pending and all users.
 * This component allows administrators to switch between viewing users
 * awaiting approval and all users in the system.
 */
export const UserManagementTab = () => {
  return (
    <Tabs defaultValue="pending" className="w-full">
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="pending">Pending Users</TabsTrigger>
        <TabsTrigger value="all">All Users</TabsTrigger>
      </TabsList>
      <TabsContent value="pending">
        <PendingUserList />
      </TabsContent>
      <TabsContent value="all">
        <UserList />
      </TabsContent>
    </Tabs>
  );
};
